import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ListCardViewComponent } from '../../../shared/components/list-card-view/list-card-view.component';
import { TagsComponent } from '../../../shared/components/tags/tags.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { ClipsFiltersComponent } from './clipping/clips-filters/clips-filters.component';
import { ClipsToolbarComponent } from './clipping/clips-toolbar/clips-toolbar.component';
import { ClipsFormComponent } from './clipping/clips-form/clips-form.component';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NavMapComponent } from '../../../shared/components/nav-map/nav-map.component';
import { take } from 'rxjs/internal/operators/take';
import { ClipTagRequest, CopyTagsRequest, GenerateClipReportRequest, ManagementClipControllerService, ManagementClipFilterRequest, ManagementClipResponse } from 'api-clipping';
import { SharedService } from '../../../shared/services/shared.service';
import { ClientFilterSubscriptionRequest, ManagementClientControllerService } from 'api-client';
import { TagsDropAssignService } from '../../../shared/services/tags-drop-assign.service';
import { Constants } from '../../../shared/interfaces/constants';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
	BankruptciesFilterRequest,
	ContractAnnouncementTagRequest,
	ContractNoticeDetailsResponse,
	ContractNoticeTagRequest,
	ManagementBankruptcyControllerService,
	ManagementBankruptcyResponse,
	ManagementBusinessEntityResponse,
	ManagementContractAnnouncementControllerService,
	ManagementContractAnnouncementResponse,
	ManagementContractNoticeAndAnnouncementFilterRequest,
	ManagementContractNoticeAndAnnouncementResponse,
	ManagementContractNoticeControllerService,
	ManagementContractNoticeResponse,
	ManagementMediumResponse,
	ManagementSaleControllerService,
	ManagementSaleResponse,
	SalesFilterRequest,
} from 'api-contract-notices';
import { ContractNoticesFormComponent } from './contract-notices/contract-notices-form/contract-notices-form.component';
import { UtilsService } from '../../../shared/services/utils.service';
import { ContractNoticesFiltersComponent } from './contract-notices/contract-notices-filters/contract-notices-filters.component';
import { ContractNoticesToolbarComponent } from './contract-notices/contract-notices-toolbar/contract-notices-toolbar.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { SalesFormComponent } from './sales/sales-form/sales-form.component';
import { SalesFiltersComponent } from './sales/sales-filters/sales-filters.component';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SalesToolbarComponent } from './sales/sales-toolbar/sales-toolbar.component';
import { BankruptciesFormComponent } from './bankruptcies/bankruptcies-form/bankruptcies-form.component';
import { BankruptciesFiltersComponent } from './bankruptcies/bankruptcies-filters/bankruptcies-filters.component';
import { BankruptciesToolbarComponent } from './bankruptcies/bankruptcies-toolbar/bankruptcies-toolbar.component';
import { TranscriptionsFormComponent } from '../../../shared/components/transcriptions/transcriptions-form/transcriptions-form.component';
import { TranscriptionsFiltersComponent } from './transcriptions/transcriptions-filters/transcriptions-filters.component';
import { TranscriptionsToolbarComponent } from './transcriptions/transcriptions-toolbar/transcriptions-toolbar.component';
import { ManagementTranscriptionControllerService, ManagementTranscriptionFilterRequest, TranscriptionResponse, PageTranscriptionResponse, ExportTranscriptionRequest, UploadControllerService, ResourceRequest, YoutubeSubtitlesResponse } from 'api-transcription';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { HttpClient, HttpEventType } from '@angular/common/http';

interface ItemForEdit {
	clip: ManagementClipResponse | undefined;
	transcription: any | undefined;
	contract_notice: ManagementContractNoticeWithParentDetails | undefined;
	contract_announcement: ManagementContractAnnouncementWithContractNoticeDetails | undefined;
	sale: ManagementSaleResponse | undefined;
	bankruptcy: ManagementBankruptcyResponse | undefined;
}

interface ManagementContractAnnouncementWithContractNoticeDetails extends ManagementContractAnnouncementResponse {
	contractAuthority?: ManagementBusinessEntityResponse;
	mediums?: ManagementMediumResponse[];
	details?: ContractNoticeDetailsResponse[];
	number?: string;
	estimatedPurchaseValue?: number;
	description?: string;
}

interface ManagementContractNoticeWithParentDetails extends ManagementContractNoticeResponse {
	parentType?: string;
}

@Component({
	selector: 'app-clips',
	standalone: true,
	imports: [
		TagsComponent,
		DragDropModule,
		ListCardViewComponent,
		MatCardModule,
		ClipsFiltersComponent,
		ClipsToolbarComponent,
		ClipsFormComponent,
		ContractNoticesFormComponent,
		NavMapComponent,
		MatTabsModule,
		TranslateModule,
		ContractNoticesFiltersComponent,
		ContractNoticesToolbarComponent,
		MatButtonModule,
		MatTooltipModule,
		MatIconModule,
		SalesFormComponent,
		SalesFiltersComponent,
		SalesToolbarComponent,
		InfiniteScrollDirective,
		BankruptciesFormComponent,
		BankruptciesFiltersComponent,
		BankruptciesToolbarComponent,
		TranscriptionsFormComponent,
		TranscriptionsFiltersComponent,
		TranscriptionsToolbarComponent,
	],
	templateUrl: './data-administration.component.html',
	styleUrl: './data-administration.component.scss',
})
export class DataAdministrationComponent implements OnInit, AfterViewInit, OnDestroy {
	private onDestroy: Subject<boolean> = new Subject();

	@ViewChild('listScrollAnchor', { static: false }) listScrollAnchor!: ElementRef;
	@ViewChild('inputFormAnchor', { static: false }) inputFormAnchor!: ElementRef;
	mobileView = false;

	dataAdministrationType: 'CLIPPING' | 'CONTRACT_NOTICES' | 'CONTRACT_ANNOUNCEMENTS' | 'SALES' | 'BANKRUPTCIES' | 'ANALYTICS' | 'TRANSCRIPTIONS' = 'CLIPPING';

	public itemsList: ManagementClipResponse[] | ManagementContractNoticeResponse[] | ManagementContractNoticeAndAnnouncementResponse[] = [];
	public itemForEdit!: ItemForEdit;

	public selectedItems: any[] = [];
	public preselectedItems: any[] = [];
	public clientsList: any[] = [];
	public highlightItemId = '';

	readonly ITEMS_PER_PAGE = 30;
	throttle = 50;
	scrollDistance = 2;
	appendModeActive = false;
	pagination = {
		active: 'LIST', // 'LIST' | 'FILTER' | 'FILTER_WITHOUT_TAGS' | 'FILTER_BY_MEDIUM',
		currentPage: 0,
		totalPages: 0,
		totalElements: 0,
	};

	public filtersStore: ManagementClipFilterRequest | ManagementContractNoticeAndAnnouncementFilterRequest | SalesFilterRequest | ManagementTranscriptionFilterRequest | undefined | boolean;
	showFilters = true;

	// Autotag UI (contract-notices), behind the backend `autotag.ui.enabled` flag. Fetched once;
	// false (today's behaviour, zero visual change) until the flag check resolves or if it errors
	// (e.g. the endpoint isn't deployed yet).
	autotagUiEnabled = false;
	private contractNoticesSortBy: 'createdAt' | 'risk' = 'createdAt';

	// scroll lock beacuse is firing multiple times on end
	// (known issue https://stackoverflow.com/questions/34822077/scroll-function-firing-multiple-times-instead-of-once)
	scrollLock = {
		locked: false,
		debounceTime: 1000,
	};
	apiLoading = false;
	relatedClipsLoading = false;

	scrollToTop = {
		initialYPos: 0,
		active: false,
	};

	constructor(
		private route: ActivatedRoute,
		public utils: UtilsService,
		private apiClippingClips: ManagementClipControllerService,
		private apiClient: ManagementClientControllerService,
		private sharedService: SharedService,
		private translate: TranslateService,
		public tagsDropAssign: TagsDropAssignService,
		private apiContractNotice: ManagementContractNoticeControllerService,
		private apiContractAnnouncements: ManagementContractAnnouncementControllerService,
		private responsive: BreakpointObserver,
		private apiSales: ManagementSaleControllerService,
		private apiBankruptcies: ManagementBankruptcyControllerService,
		private apiTranscriptions: ManagementTranscriptionControllerService,
		private matDialog: MatDialog,
		private apiTranscriptionUpload: UploadControllerService,
		private http: HttpClient
	) {
		this.responsive
			.observe([Breakpoints.XSmall, Breakpoints.Small])
			.pipe(takeUntilDestroyed())
			.subscribe(result => {
				this.mobileView = false;

				if (result.matches) {
					this.mobileView = true;
				}
			});
	}

	ngOnInit(): void {
		this.loadAutotagFlags();

		this.route.params.pipe(takeUntil(this.onDestroy)).subscribe(params => {
			this.dataAdministrationType = Constants.ADMINISTRATION_DATA_TYPES.get(params['type']) || 'CLIPPING';

			this.appendModeActive = false;
			this.itemsList = [];
			this.itemForEdit = {
				clip: undefined,
				transcription: undefined,
				contract_notice: undefined,
				contract_announcement: undefined,
				sale: undefined,
				bankruptcy: undefined,
			};
			this.selectedItems = [];
			this.preselectedItems = [];
			this.clientsList = [];
			this.filtersStore = false;

			this.actionByTypeSplitter({
				action: 'LOAD',
				id: 0, // this is used only in clipping (review it if filter api is optimized)
			});
		});
	}

	ngOnDestroy(): void {
		this.onDestroy.next(true);
	}

	/** Autotag UI feature flag - checked once. Silently stays false (today's behaviour) if the
	 * endpoint 404s/errors, which is expected while the backend side isn't deployed yet. */
	private loadAutotagFlags(): void {
		this.apiContractNotice
			.getAutotagFlags()
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.autotagUiEnabled = !!response.uiEnabled;
				},
				error: () => {
					this.autotagUiEnabled = false;
				},
			});
	}

	ngAfterViewInit(): void {
		// this.actionByTypeSplitter({
		// 	action: 'TAGS_SELECTION_CHANGE',
		// });
	}

	scrollPosition(event: any) {
		if (!this.scrollToTop.initialYPos && this.listScrollAnchor) {
			this.scrollToTop.initialYPos = this.listScrollAnchor.nativeElement.getBoundingClientRect().top;
		}

		this.scrollToTop.active = this.scrollToTop.initialYPos > 2.5 * this.listScrollAnchor.nativeElement.getBoundingClientRect().top;
	}

	/** Virtual scroll methods */
	onScrollDown(event: any) {
		if (!this.scrollLock.locked && !this.apiLoading) {
			this.appendModeActive = true;
			this.scrollLock.locked = true;
			if (this.filtersStore) {
				this.actionByTypeSplitter({
					action: 'FILTER',
					data: 'list',
					filters: this.filtersStore,
				});
			} else {
				this.actionByTypeSplitter({
					action: 'LOAD',
					data: 'list',
				});
			}

			setTimeout(() => {
				this.scrollLock.locked = false;
			}, this.scrollLock.debounceTime);
		}
	}

	private paginationState(active: 'LIST' | 'FILTER' | 'FILTER_BY_MEDIUM', startIndex?: number) {
		if (this.pagination.active !== active || startIndex === 0) {
			if (this.listScrollAnchor) {
				this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
			}
			this.appendModeActive = false;
		}

		this.pagination.active = active;
		if (startIndex === 0) {
			this.pagination.currentPage = 0;
			this.pagination.totalPages = 1;
			this.appendModeActive = false;
			this.preselectedItems = [];
		} else {
			startIndex = ++this.pagination.currentPage;
		}

		return this.pagination.currentPage <= this.pagination.totalPages - 1;
	}

	private setPaginationState(totalElements: number, itemsPerPage?: number) {
		this.pagination.totalPages = totalElements ? Math.ceil(totalElements / this.ITEMS_PER_PAGE) : 0;
		if (itemsPerPage !== undefined) {
			this.pagination.currentPage = itemsPerPage / this.ITEMS_PER_PAGE;
			setTimeout(() => {
				this.scrollElementIntoView(this.highlightItemId);
			}, 500);
		}
	}

	private scrollElementIntoView(id: string) {
		let el = document.getElementById(id);
		if (el) {
			this.highlightItemId = id;
			el.scrollIntoView({ behavior: 'instant', block: 'center' });
		}
		setTimeout(() => {
			// how long will the highlight last
			this.highlightItemId = '';
		}, 2000);
	}
	/** (END)Virtual scroll methods */

	actionByTypeSplitter(event: any) {
		switch (this.dataAdministrationType) {
			case 'CLIPPING': {
				this.actionRequestedClipping(event);
				break;
			}
			case 'TRANSCRIPTIONS': {
				this.actionRequestedTranscription(event);
				break;
			}
			case 'CONTRACT_NOTICES':
			case 'CONTRACT_ANNOUNCEMENTS': {
				this.actionRequestedContractNotices(event);
				break;
			}
			case 'SALES': {
				this.actionRequestedSale(event);
				break;
			}
			case 'BANKRUPTCIES': {
				this.actionRequestedBankruptcy(event);
				break;
			}
		}
	}

	//** Clipping methods */
	actionRequestedClipping(event: any) {
		// this.appendModeActive = false;
		switch (event.action) {
			case 'LOAD': {
				if (this.clientsList.length === 0) {
					// Initial client list loading
					this.getClientList('CLIPPING');
				}
				// if (event.data === 'listItem') {
				// 	this.getClip(event.id);
				// } else if (event.data === 'filterCheck') {
				// 	this.highlightItemId = event.id;
				// 	this.preselectedItems = [];
				// 	this.filterClipsStateCheck();
				// } else {
				// 	this.getClips(event.id);
				// }
        		if (event.data === 'listItem') {
					this.getClip(event.id);
				} else {
					this.sharedService.requestActionInComponent.next({
						componentName: 'ClipsFiltersComponent',
						action: 'FILTER_TRIGGER',
						data: {
							dataAdministrationType: this.dataAdministrationType,
						},
					});
				}
				break;
			}
			case 'FILTER': {
				this.filterClips(event.filters, event.id);
				break;
			}
			// case 'FILTER_BY_MEDIUM': {
			// 	this.filterByMedium(event.filters, event.id);
			// 	break;
			// }
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'UNSELECT_ALL': {
				this.selectedItems = [];
				this.unselectAllItems();
				break;
			}
			case 'RELATED_CLIPS_LOADING': {
				this.relatedClipsLoading = event.loading;
				break;
			}
			case 'TOOLBAR': {
				if (event.groupAction === 'DELETE' && this.selectedItems.length) {
					this.deleteClips(
						this.selectedItems.map(item => item.id),
						this.selectedItems[0].groupId
					);
				} else if (event.groupAction === 'CREATE_GROUP' && this.selectedItems.length) {
					this.splitClips(
						this.selectedItems.map(item => item.id),
						this.selectedItems[0].groupId
					);
				} else if (event.groupAction === 'MERGE_GROUP') {
					if (this.selectedItems.length) {
						if (event.item) {
							this.selectedItems.push(event.item);
						}

						// CLIPPING-614: which group's main Clip survives the merge is decided entirely by
						// the backend (ClipUtils.resolveMainClipAcrossGroups) - the OLDER of the merged
						// groups' main Clips wins, unless a younger group's main is a strictly stronger
						// medium type (TV > Radio > Printed > Web > Social). groupId here only tells the
						// backend where the selected Clips physically end up; it does not decide who wins.
						// The medium/relatedCount/createdAt comparison used to be re-implemented here,
						// which both duplicated that rule and ignored it on a tie (e.g. two WEB groups).
						this.mergeClips(
							this.selectedItems[0].groupId,
							this.selectedItems.map(item => item.id)
						);
					} else {
						// this.getClips(0);
            			this.actionByTypeSplitter({ action: 'LOAD' });
					}
				} else if (event.groupAction === 'COPY_GROUP' && this.selectedItems.length) {
					this.cloneClips(
						this.selectedItems.map(item => item.id),
						this.selectedItems[0].groupId
					);
				} else if (event.groupAction === 'ADD_TAGS' && event.tags && this.selectedItems.length) {
					this.assignTags(
						this.selectedItems.map(item => item.id),
						event.tags.map((item: any) => item.id)
					);
				} else if (event.groupAction === 'COPY_TAGS') {
					this.copyTagsToGroup();
				} else if (event.groupAction === 'DELETE_DUPLICATES' && this.selectedItems.length) {
					this.deleteDuplicates(
						this.selectedItems.map(item => item.id),
						this.selectedItems[0].groupId
					);
				} else if (event.groupAction === 'GENERATE_REPORT' && this.selectedItems.length) {
					this.generatePdfReport(this.selectedItems.map(item => item.id));
				} else if (event.groupAction === 'UNLINK_FROM_GROUP' && this.selectedItems.length) {
					this.unlinkClipsFromGroup(
						this.selectedItems.map(item => item.id),
						this.selectedItems[0].groupId
					);
				} else if (event.groupAction === 'SCROLL_TO_TOP' && this.listScrollAnchor) {
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
					this.scrollToTop.active = false;
				}
				break;
			}
			case 'SET_AS_MAIN': {
				this.setClipAsMain(event.item.id, event.item.groupId);
				break;
			}
			case 'GENERATE_REPORT': {
				if (event.type === 'GROUP') {
					this.generatePdfReportForMain(event.item.groupId);
				} else if (event.type === 'SINGLE') {
					this.generatePdfReport([event.item.id]);
				}
				break;
			}
		}

		// this.sharedService.requestActionInComponent.next({
		// 	componentName: 'ClipsFormComponent',
		// 	action: 'RESET_FORM',
		// });
	}

	// private getClips(startIndex?: number, itemsPerPage?: number) {
	// 	this.filtersStore = undefined;

	// 	if (this.paginationState('LIST', startIndex)) {
	// 		this.apiLoading = true;
	// 		this.apiClippingClips
	// 			.getClipsPageable(this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE)
	// 			.pipe(take(1))
	// 			.subscribe({
	// 				next: response => {
	// 					this.itemsList = response.content || [];
	// 					this.setPaginationState(response.totalElements || 0, itemsPerPage);
	// 					this.pagination.totalPages = response.totalPages || 0;
	// 					this.pagination.totalElements = response.totalElements || 0;
	// 					this.apiLoading = false;
	// 				},
	// 				error: () => {
	// 					this.itemsList = [];
	// 					this.pagination.totalPages = 0;
	// 					this.apiLoading = false;
	// 				},
	// 			});
	// 	}
	// }

	private getClip(clipId: string) {
		this.apiClippingClips
			.getClipById(clipId)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.itemForEdit.clip = response;
					this.inputFormAnchor.nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
					this.apiLoading = false;
				},
			});
	}

	private deleteClips(clipIds: string[], groupId: string) {
		this.apiLoading = true;
		this.apiClippingClips
			.deleteClips({ clipIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_DELETED'),
						type: 'SUCCESS',
					});
					this.actionRequestedClipping({ action: 'LOAD', data: 'filterCheck', id: 'tag-dropzone-list-' + groupId });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private mergeClips(groupId: string, clipIds: any) {
		this.apiLoading = true;
		this.apiClippingClips
			.mergeClips({ groupId, clipIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.actionRequestedClipping({ action: 'LOAD', data: 'filterCheck', id: 'tag-dropzone-list-' + groupId });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private splitClips(clipIds: string[], groupId: string) {
		this.apiLoading = true;
		this.apiClippingClips
			.splitClips({ clipIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.actionRequestedClipping({ action: 'LOAD', data: 'filterCheck', id: 'tag-dropzone-list-' + groupId });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private cloneClips(clipIds: string[], groupId: string) {
		this.apiLoading = true;
		this.apiClippingClips
			.cloneClips({ clipIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.actionRequestedClipping({ action: 'LOAD', data: 'filterCheck', id: 'tag-dropzone-list-' + groupId });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private assignTags(dataIds: string[], tagIds: string[]) {
		this.apiLoading = true;
		const tagDto: ClipTagRequest = {
			dataIds,
			tagIds,
		};
		this.apiClippingClips
			.addTags(tagDto)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.preselectedItems = [];
					// this.getClips(0);
	            	this.actionByTypeSplitter({ action: 'LOAD' });
					this.sharedService.requestActionInComponent.next({
						componentName: 'TagsComponent',
						action: 'DESELECT_TAGS',
					});
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.preselectedItems = [];
					this.apiLoading = false;
				},
			});
	}

	private copyTagsToGroup() {
		if (!this.selectedItems.length) {
			return;
		}

		const mainClips = this.selectedItems.filter(item => item.main);
		if (mainClips.length != 2) {
			return;
		}
	
		this.apiLoading = true;
		const copyTagsRequest: CopyTagsRequest = {
			clipIds: mainClips.map(clip => clip.id)
		};
		this.apiClippingClips
			.copyClipsTags(copyTagsRequest)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.preselectedItems = [];
					this.actionByTypeSplitter({ action: 'LOAD' });
					this.sharedService.requestActionInComponent.next({
						componentName: 'TagsComponent',
						action: 'DESELECT_TAGS',
					});
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.preselectedItems = [];
					this.apiLoading = false;
				}
			});
	}

	private deleteDuplicates(clipIds: string[], groupId: string) {
		this.apiLoading = true;
		this.apiClippingClips
			.deleteDuplicateClips({ clipIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.actionRequestedClipping({ action: 'LOAD', data: 'filterCheck', id: 'tag-dropzone-list-' + groupId });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private getClientList(subscriptionType: 'CLIPPING' | 'TRANSCRIPTIONS' | 'CONTRACT_NOTICES' = 'CLIPPING') {
		const clientFilterSubscriptionRequest: ClientFilterSubscriptionRequest = {
			subscriptions: [subscriptionType],
			statuses: ["ACTIVE"],
		};

		this.apiClient
			.getClients(clientFilterSubscriptionRequest, 0, 1000)
			.pipe(take(1))
			.subscribe({
				next: response => {
					if (response.content) {
						this.clientsList = response.content;
					}
				},
				error: () => {
					// Handle error
				},
			});
	}

	private generatePdfReport(clipIds: string[]) {
		this.apiLoading = true;
		this.apiClippingClips
			.generatePdfReportForAllClipsByIds({
				clipIds,
				lang: this.utils.currentLanguage.toUpperCase() as GenerateClipReportRequest.LangEnum,
			})
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private generatePdfReportForMain(groupId: string) {
		this.apiLoading = true;
		this.apiClippingClips
			.generatePdfReportForMainClipWithRelated({
				groupId,
				lang: this.utils.currentLanguage.toUpperCase() as GenerateClipReportRequest.LangEnum,
			})
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private unlinkClipsFromGroup(clipIds: string[], groupId: string) {
		this.apiLoading = true;
		this.apiClippingClips
			.splitClipsWithClusters({ clipIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.actionRequestedClipping({ action: 'LOAD', data: 'filterCheck', id: 'tag-dropzone-list-' + groupId });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private setClipAsMain(clipId: string, groupId: string) {
		this.apiLoading = true;
		this.apiClippingClips
			.updateClipToMain({ main: true }, clipId)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_CREATED'),
						type: 'SUCCESS',
					});
					this.actionRequestedClipping({ action: 'LOAD', data: 'filterCheck', id: 'tag-dropzone-list-' + groupId });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	// private filterClipsStateCheck() {
	// 	this.appendModeActive = true;
	// 	if (this.filtersStore && (this.filtersStore as FilterRequest).mediumId) {
	// 		//this.filterByMedium(this.filtersStore as FilterRequest, 0, this.pagination.currentPage * this.ITEMS_PER_PAGE);
  //     this.filterClips(this.filtersStore as FilterRequest, 0, this.pagination.currentPage * this.ITEMS_PER_PAGE);
	// 	} else if (this.filtersStore) {
	// 		this.filterClips(this.filtersStore as FilterRequest, 0, this.pagination.currentPage * this.ITEMS_PER_PAGE);
	// 	} else {
	// 		this.getClips(0, this.pagination.currentPage * this.ITEMS_PER_PAGE);
	// 	}
	// }

	private filterClips(filters: ManagementClipFilterRequest, startIndex?: number, itemsPerPage?: number) {
		this.filtersStore = filters;
		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
      // this.apiClippingClips.getFilteredClipsPageable(filters, this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE)
			this.apiClippingClips.getClipsPageableFilter(filters, this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE)
				.pipe(take(1))
				.subscribe({
					next: response => {
						// this.itemsList = response.content || [];
						// this.setPaginationState(response.totalElements || 0, itemsPerPage);
						// this.apiLoading = false;
            			this.itemsList = response.content || [];
						this.pagination.totalPages = response.totalPages || 0;
						this.pagination.totalElements = response.totalElements || 0;
						this.apiLoading = false;
					},
					error: err => {
						this.sharedService.showNotification.next({
							message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
							type: 'ERROR',
						});
						this.apiLoading = false;
					},
				});
		}
	}

	// private filterByMedium(filters: FilterRequest, startIndex?: number, itemsPerPage?: number) {
	// 	this.filtersStore = filters;

	// 	if (this.paginationState('FILTER_BY_MEDIUM', startIndex)) {
	// 		this.apiLoading = true;
	// 		this.apiClippingClips
	// 			.getFilteredClipsByMediumPageable(filters, this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE)
	// 			.pipe(take(1))
	// 			.subscribe({
	// 				next: response => {
	// 					this.itemsList = response.content || [];
	// 					this.setPaginationState(response.totalElements || 0, itemsPerPage);
	// 					this.apiLoading = false;
	// 				},
	// 				error: err => {
	// 					this.sharedService.showNotification.next({
	// 						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
	// 						type: 'ERROR',
	// 					});
	// 					this.apiLoading = false;
	// 				},
	// 			});
	// 	}
	// }
	//** (END) Clipping methods */

	//** Transcription methods */
	actionRequestedTranscription(event: any) {
		switch (event.action) {
			case 'LOAD': {
				if (event.item) {
					// Edit transcription
					this.editTranscription(event.item);
				} else {
					// Initial load
					if (this.clientsList.length === 0) {
						this.getClientList('TRANSCRIPTIONS');
					}
					this.sharedService.requestActionInComponent.next({
						componentName: 'TranscriptionsFiltersComponent',
						action: 'FILTER_TRIGGER',
					});
				}
				break;
			}
			case 'FILTER': {
				this.getTranscriptionsWithFilters(event.filters, event.id);
				break;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'UNSELECT_ALL': {
				this.selectedItems = [];
				this.unselectAllItems();
				break;
			}
			case 'CREATE_TRANSCRIPTION': {
				this.openCreateTranscriptionDialog();
				break;
			}
			case 'CREATE_TRANSCRIPTION_FROM_RECORDING': {
				this.createTranscriptionFromRecording(event.audioFile);
				break;
			}
			case 'EXPORT_TRANSCRIPTION': {
				this.exportTranscription(event.item);
				break;
			}
			case 'FORM_CLOSED': {
				this.itemForEdit.transcription = null;
				break;
			}
			case 'TOOLBAR': {
				if (event.groupAction === 'DELETE' && this.selectedItems.length) {
					this.deleteTranscriptions(this.selectedItems.map(item => item.id));
				} else if (event.groupAction === 'ADD_TAGS' && event.tags && this.selectedItems.length) {
					this.assignTagsTranscriptions(
						this.selectedItems.map(item => item.id),
						event.tags.map((item: any) => item.id)
					);
				} else if (event.groupAction === 'SCROLL_TO_TOP' && this.listScrollAnchor) {
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
					this.scrollToTop.active = false;
				}
				break;
			}
		}
	}

	private getTranscriptionsWithFilters(filters: ManagementTranscriptionFilterRequest, startIndex?: number, itemsPerPage?: number) {
		this.filtersStore = filters;
		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			this.apiTranscriptions
				.getMgmtTranscriptionsPageableFilter(filters, this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE)
				.pipe(take(1))
				.subscribe({
					next: (response: PageTranscriptionResponse) => {
						this.itemsList = response.content || [];
						// CLIPPING-592: the backend only computes totalElements/totalPages on page 0
						// (count query is skipped on later pages) - keep the cached value from that
						// first page instead of overwriting it with the now-absent fields.
						if (response.totalElements !== undefined && response.totalElements !== null) {
							this.pagination.totalPages = response.totalPages || 0;
							this.pagination.totalElements = response.totalElements;
						}
						this.apiLoading = false;
					},
					error: () => {
						this.apiLoading = false;
						this.sharedService.showNotification.next({
							message: this.translate.instant('NOTIFICATIONS.ACTION_ERROR'),
							type: 'ERROR',
						});
					},
				});
		}
	}

	private deleteTranscriptions(transcriptionIds: string[]) {
		this.apiLoading = true;
		this.apiTranscriptions
			.deleteMgmtTranscriptions({ transcriptionIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_DELETED'),
						type: 'SUCCESS',
					});
					this.selectedItems = [];
					this.actionRequestedTranscription({ action: 'FILTER', filters: this.filtersStore });
					this.apiLoading = false;
				},
				error: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR'),
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private assignTagsTranscriptions(transcriptionIds: string[], tagIds: string[]) {
		this.apiLoading = true;
		this.apiTranscriptions
			.addTranscriptionsTags({ dataIds: transcriptionIds, tagIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.selectedItems = [];
					this.actionRequestedTranscription({ action: 'FILTER', filters: this.filtersStore });
					this.apiLoading = false;
				},
				error: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR'),
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private editTranscription(transcription: any) {
		this.itemForEdit.transcription = transcription;
		if (this.inputFormAnchor) {
			this.inputFormAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	private exportTranscription(transcription: any) {
		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '400px',
			data: {
				type: 'custom-fields',
				mode: 'EXPORT',
				fields: [
					{
						type: 'selection',
						key: 'format',
						label: this.translate.instant('TRANSCRIPTIONS.FORMAT'),
						required: true,
						data: [
							{ value: 'DOCX', label: 'DOCX' },
							{ value: 'TXT', label: 'TXT' },
							{ value: 'SRT', label: 'SRT' }
						]
					},
					{
						type: 'checkbox',
						key: 'mergeText',
						label: this.translate.instant('TRANSCRIPTIONS.MERGE_TEXT'),
						default: false,
						hideWhenSRT: true
					},
					{
						type: 'checkbox',
						key: 'includeSpeakers',
						label: this.translate.instant('TRANSCRIPTIONS.INCLUDE_SPEAKERS'),
						default: true,
						hideWhenMergeText: true
					},
					{
						type: 'checkbox',
						key: 'includeTimestamps',
						label: this.translate.instant('TRANSCRIPTIONS.INCLUDE_TIMESTAMPS'),
						default: true,
						hideWhenMergeText: true,
						hideWhenSRT: true
					}
				]
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.data) {
				const exportRequest: ExportTranscriptionRequest = {
					format: result.data.format,
					mergeText: result.data.mergeText,
					includeSpeakers: result.data.includeSpeakers,
					includeTimestamps: result.data.includeTimestamps
				};

				this.apiLoading = true;
				this.apiTranscriptions.exportMgmtTranscription(exportRequest, transcription.id).subscribe({
					next: (response: any) => {
						this.apiLoading = false;
						this.downloadFile(response, transcription.fileName, result.data.format);
					},
					error: error => {
						this.apiLoading = false;
						this.sharedService.showNotification.next({
							message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${error.error?.message || error.message}`,
							type: 'ERROR',
						});
					}
				});
			}
		});
	}

	private downloadFile(data: any, fileName: string, format: string) {
		const blob = new Blob([data], { type: this.getContentType(format) });
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = `${fileName}.${format.toLowerCase()}`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);
	}

	private getContentType(format: string): string {
		switch (format) {
			case 'DOCX':
				return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			case 'TXT':
				return 'text/plain';
			case 'SRT':
				return 'text/plain';
			default:
				return 'application/octet-stream';
		}
	}

	openCreateTranscriptionDialog() {
		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				fields: [
					{
						type: 'textfield',
						label: 'TRANSCRIPTIONS.TYPES.URL',
						key: 'url'
					},
					{
						type: 'file',
						label: 'TRANSCRIPTIONS.TYPES.FILE',
						key: 'file'
					},
					{
						type: 'selection',
						label: 'TRANSCRIPTIONS.LANG',
						key: 'lang',
						data: [
							{ value: 'MK', name: this.translate.instant('NAVBAR.LANGUAGES.MK'), default: true },
							{ value: 'EN', name: this.translate.instant('NAVBAR.LANGUAGES.EN') },
							{ value: 'AL', name: this.translate.instant('NAVBAR.LANGUAGES.AL') }
						]
					}
				]
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (!result || !result.data) {
				return;
			}

			const isFileUpload = !!result.data.file;
			const url = isFileUpload ? '' : (result.data.url || '');
			const request: any = {
				url,
				lang: result.data.lang,
				fileUpload: isFileUpload
			};

			if (!isFileUpload && this.isYoutubeUrl(url)) {
				this.checkYoutubeSubtitlesThenCreate(request, result.data.file);
				return;
			}

			this.createTranscription(request, result.data.file);
		});
	}

	/** Matches the youtube-detection in the transcription service's TranscriptionUtils.isYoutubeUrl. */
	private isYoutubeUrl(url: string): boolean {
		const lower = (url || '').toLowerCase();
		return lower.includes('youtube.com') || lower.includes('youtu.be');
	}

	private checkYoutubeSubtitlesThenCreate(request: any, file: File | null) {
		this.apiLoading = true;

		this.apiTranscriptions.checkYoutubeSubtitles(request.url, request.lang)
			.pipe(take(1))
			.subscribe({
				next: (response: YoutubeSubtitlesResponse) => {
					this.apiLoading = false;

					if (response?.kind === 'MANUAL' && response.subtitleUrl) {
						// Manually written subtitles are trustworthy - use them without asking, just let the user know.
						this.sharedService.showNotification.next({
							message: this.translate.instant('TRANSCRIPTIONS.YOUTUBE_SUBTITLES_MANUAL_FOUND_MESSAGE'),
							type: 'SUCCESS',
						});
						request.subtitleUrl = response.subtitleUrl;
						this.createTranscription(request, file);
					} else if (response?.kind === 'AUTOMATIC' && response.subtitleUrl) {
						this.openAutoSubtitlesChoiceDialog(response, request, file);
					} else if (response?.kind === 'CHECK_FAILED') {
						// The check itself failed (yt-dlp error on both clients) - distinct from a
						// successful check that genuinely found nothing (CLIPPING-576 point 4).
						this.openSubtitleCheckFailedConfirmDialog(request, file);
					} else {
						this.openNoYoutubeSubtitlesConfirmDialog(request, file);
					}
				},
				error: () => {
					// Check failed (network hiccup, yt-dlp error, etc.) - never block creation, just proceed as if no subtitles exist.
					this.apiLoading = false;
					this.createTranscription(request, file);
				}
			});
	}

	/** Successful check, but no subtitles at all - confirm before falling back to a full video download + AI transcription. */
	private openNoYoutubeSubtitlesConfirmDialog(request: any, file: File | null) {
		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				skipFormValidation: true,
				message: 'TRANSCRIPTIONS.NO_YOUTUBE_SUBTITLES_MESSAGE',
				fields: []
			}
		});

		dialogRef.afterClosed()
			.pipe(take(1))
			.subscribe(result => {
				if (result && result.data) {
					this.createTranscription(request, file);
				}
				// else: cancelled - no transcription created, no video downloaded.
			});
	}

	/** The check itself couldn't run (yt-dlp error) - unlike the dialog above, this does NOT
	 *  claim the video has no subtitles, since we never actually found out either way. */
	private openSubtitleCheckFailedConfirmDialog(request: any, file: File | null) {
		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				skipFormValidation: true,
				message: 'TRANSCRIPTIONS.YOUTUBE_SUBTITLES_CHECK_FAILED_MESSAGE',
				fields: []
			}
		});

		dialogRef.afterClosed()
			.pipe(take(1))
			.subscribe(result => {
				if (result && result.data) {
					this.createTranscription(request, file);
				}
				// else: cancelled - no transcription created, no video downloaded.
			});
	}

	/** Only auto-generated subtitles exist - let the user pick between the lower-quality subtitles and our own transcription. */
	private openAutoSubtitlesChoiceDialog(subtitles: YoutubeSubtitlesResponse, request: any, file: File | null) {
		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				skipFormValidation: true,
				message: 'TRANSCRIPTIONS.YOUTUBE_SUBTITLES_AUTO_MESSAGE',
				fields: [
					{
						type: 'radio',
						key: 'useSubtitles',
						options: ['SUBTITLES', 'AI'],
						optionLabels: [
							this.translate.instant('TRANSCRIPTIONS.USE_YOUTUBE_SUBTITLES'),
							this.translate.instant('TRANSCRIPTIONS.TRANSCRIBE_AUDIO_OURSELVES')
						],
						defaultValue: 'SUBTITLES'
					}
				]
			}
		});

		dialogRef.afterClosed()
			.pipe(take(1))
			.subscribe(result => {
				if (!result || !result.data) {
					// cancelled (closed via X) - no transcription created, no video downloaded.
					return;
				}
				if (result.data.useSubtitles === 'SUBTITLES') {
					request.subtitleUrl = subtitles.subtitleUrl;
				}
				this.createTranscription(request, file);
			});
	}

	private createTranscription(request: any, file: File | null) {
		this.apiLoading = true;

		if (file && (request.fileUpload || request.recording)) {
			this.uploadFileToB2AndCreateTranscription(request, file);
		} else {
			this.apiTranscriptions.createMgmtTranscription(request)
				.pipe(take(1))
				.subscribe({
					next: () => {
						this.apiLoading = false;
						this.sharedService.showNotification.next({
							message: this.translate.instant('NOTIFICATIONS.RECORD_CREATED'),
							type: 'SUCCESS',
						});
						this.actionRequestedTranscription({ action: 'FILTER', filters: this.filtersStore });
					},
					error: error => {
						this.apiLoading = false;
						this.sharedService.showNotification.next({
							message: error.status === 409
								? this.translate.instant('TRANSCRIPTIONS.VIDEO_ALREADY_DOWNLOADED')
								: `${this.translate.instant('TRANSCRIPTIONS.CREATED_ERROR')} \n ${error.error?.message || error.message}`,
							type: 'ERROR',
						});
					}
				});
		}
	}

	private createTranscriptionFromRecording(audioFile: File) {
		const request = {
			url: '',
			lang: this.translate.currentLang?.toUpperCase() || 'MK',
			fileUpload: false,
			recording: true
		};

		this.createTranscription(request, audioFile);
	}

	private uploadFileToB2AndCreateTranscription(request: any, file: File) {
		const uploadRequest: ResourceRequest = {
			filename: file.name,
			contentType: file.type,
			type: 'TRANSCRIPTION',
			fileSize: file.size
		};

		this.apiTranscriptionUpload.generatePreSignedUrls([uploadRequest])
			.pipe(take(1))
			.subscribe({
				next: response => {
					if (response && response[0]) {
						const uploadUrl = response[0].uploadUrl;
						const cdnUrl = response[0].cdnUrl;

						if (uploadUrl && cdnUrl) {
							this.uploadFileToPresignedUrl(file, uploadUrl, cdnUrl, request);
						} else {
							this.apiLoading = false;
							this.sharedService.showNotification.next({
								message: this.translate.instant('TRANSCRIPTIONS.UPLOAD_ERROR'),
								type: 'ERROR',
							});
						}
					}
				},
				error: error => {
					this.apiLoading = false;
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('TRANSCRIPTIONS.UPLOAD_ERROR')} \n ${error.error?.message || error.message}`,
						type: 'ERROR',
					});
				}
			});
	}

	private uploadFileToPresignedUrl(file: File, uploadUrl: string, cdnUrl: string, transcriptionRequest: any) {
		const reader = new FileReader();
		reader.readAsArrayBuffer(file);
		reader.onload = (event: any) => {
			const content = event.target.result;

			this.http.put(uploadUrl, content, {
				headers: { 'Content-Type': file.type },
				reportProgress: true,
				observe: 'events'
			}).subscribe({
				next: (response: any) => {
					if (response.type === HttpEventType.Response && response.ok) {
						const updatedRequest = {
							...transcriptionRequest,
							url: cdnUrl,
							fileUpload: transcriptionRequest.recording ? false : true
						};

						this.apiTranscriptions.createMgmtTranscription(updatedRequest)
							.pipe(take(1))
							.subscribe({
								next: () => {
									this.apiLoading = false;
									this.sharedService.showNotification.next({
										message: this.translate.instant('NOTIFICATIONS.RECORD_CREATED'),
										type: 'SUCCESS',
									});
									this.actionRequestedTranscription({ action: 'FILTER', filters: this.filtersStore });
								},
								error: error => {
									this.apiLoading = false;
									this.sharedService.showNotification.next({
										message: `${this.translate.instant('TRANSCRIPTIONS.CREATED_ERROR')} \n ${error.error?.message || error.message}`,
										type: 'ERROR',
									});
								}
							});
					}
				},
				error: error => {
					this.apiLoading = false;
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('TRANSCRIPTIONS.UPLOAD_ERROR')} \n ${error.error?.message || error.message}`,
						type: 'ERROR',
					});
				}
			});
		};
	}
	//** (END) Transcription methods */

	//** Contract Notices methods */
	private actionRequestedContractNotices(event: any) {
		switch (event.action) {
			case 'LOAD': {
				if (event.data === 'listItem') {
					if (event.item.announcementType) {
						this.getContractAnnouncement(event.id);
					} else {
						this.getContractNotice(event.id);
					}
				} else {
					this.sharedService.requestActionInComponent.next({
						componentName: 'ContractNoticesFiltersComponent',
						action: 'FILTER_TRIGGER',
						data: {
							dataAdministrationType: this.dataAdministrationType,
						},
					});
				}
				return;
			}
			case 'FILTER': {
				this.contractNoticesSortBy = event.sortBy || 'createdAt';
				this.filterContractNotices(event.filters, event.id);
				return;
			}
			case 'REVIEW': {
				this.reviewContractNotice(event.item);
				return;
			}
			case 'TAGS_SELECTION_CHANGE': {
				this.sharedService.requestActionInComponent.next({
					componentName: 'ContractNoticesFiltersComponent',
					action: 'FILTER_TRIGGER',
				});
				break;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'UNSELECT_ALL': {
				this.selectedItems = [];
				this.unselectAllItems();
				break;
			}
			case 'GENERATE_REPORT': {
				if (event.type === 'SINGLE') {
					if (event.item.fileUrl && this.isPdfFile(event.item.fileUrl)) {
						window.open(event.item.fileUrl, '_blank');
					} else if (event.item.announcementType) {
						this.generateContractAnnouncementPdfReport(event.item.id);
					} else {
						this.generateContractNoticePdfReport(event.item.id);
					}
				}
				break;
			}
			case 'TOOLBAR': {
				const selectedContractNotices: any[] = [];
				const selectedContractAnnouncements: any[] = [];

				this.selectedItems.forEach(item => {
					if (item.announcementType) {
						selectedContractAnnouncements.push(item);
					} else if (item.noticeType) {
						selectedContractNotices.push(item);
					}
				});

				if (event.groupAction === 'REVIEW_BULK') {
					// Selected rows if anything is checked, otherwise every row currently visible
					// in the list (the toolbar button has no selection requirement for this action).
					const targetIds = (this.selectedItems.length ? selectedContractNotices : (this.itemsList as any[]).filter(item => item.noticeType)).map((item: any) => item.id);
					this.reviewContractNoticesBulk(targetIds);
				} else if (event.groupAction === 'DELETE') {
					if (selectedContractAnnouncements.length) {
						this.deleteContractAnnouncement(selectedContractAnnouncements.map(item => item.id));
					}
					if (selectedContractNotices.length) {
						this.deleteContractNotice(selectedContractNotices.map(item => item.id));
					}
				} else if (event.groupAction === 'ADD_TAGS' && event.tags) {
					if (selectedContractAnnouncements.length) {
						this.assignTagsContractAnnouncements(
							selectedContractAnnouncements.map(item => item.id),
							event.tags.map((item: any) => item.id)
						);
					}
					if (selectedContractNotices.length) {
						this.assignTagsContractNotices(
							selectedContractNotices.map(item => item.id),
							event.tags.map((item: any) => item.id)
						);
					}
				} else if (event.groupAction === 'COPY') {
					if (selectedContractNotices.length) {
						this.copyContractNotice(selectedContractNotices.map(item => item.id));
					}
					if (selectedContractAnnouncements.length) {
						this.copyContractAnnouncement(selectedContractAnnouncements.map(item => item.id));
					}
				} else if (event.groupAction === 'SCROLL_TO_TOP' && this.listScrollAnchor) {
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
					this.scrollToTop.active = false;
				} else if (event.groupAction === 'COPY_TAGS') {
					let itemWithTags!: ManagementContractNoticeAndAnnouncementResponse;
					let itemToAssignTags!: ManagementContractNoticeAndAnnouncementResponse;
					if (selectedContractNotices.length) {
						selectedContractNotices.forEach(cn => {
							if (cn.tags.length > 0) {
								itemWithTags = cn;
							} else {
								itemToAssignTags = cn;
							}
						});

						if (itemWithTags && itemWithTags.tags && itemToAssignTags && itemToAssignTags.id) {
							this.assignTagsContractNotices(
								[itemToAssignTags.id],
								itemWithTags.tags.map((item: any) => item.id)
							);
						}
					} else if (selectedContractAnnouncements.length) {
						if (selectedContractAnnouncements.length) {
							selectedContractAnnouncements.forEach(cn => {
								if (cn.tags.length > 0) {
									itemWithTags = cn;
								} else {
									itemToAssignTags = cn;
								}
							});
						}

						if (itemWithTags && itemWithTags.tags && itemToAssignTags && itemToAssignTags.id) {
							this.assignTagsContractAnnouncements(
								[itemToAssignTags.id],
								itemWithTags.tags.map((item: any) => item.id)
							);
						}
					}
				}

				break;
			}
		}

		this.sharedService.requestActionInComponent.next({
			componentName: 'ContractNoticesFormComponent',
			action: 'RESET_FORM',
		});
	}

	private getContractNotice(id: string) {
		this.apiContractNotice
			.getContractNoticeById(id)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.itemForEdit.contract_notice = response;
					this.inputFormAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
				},
			});
	}

	private getContractAnnouncement(id: string) {
		this.apiContractAnnouncements
			.getContractAnnouncementById(id)
			.pipe(take(1))
			.subscribe({
				next: response => {
					if (this.dataAdministrationType === 'CONTRACT_NOTICES') {
						this.itemForEdit.contract_notice = response.contractNotice;
						if (this.itemForEdit.contract_notice) {
							this.itemForEdit.contract_notice.publishedDate = response.publishedDate;
							this.itemForEdit.contract_notice.url = response.url;
							this.itemForEdit.contract_notice.id = response.id;
							this.itemForEdit.contract_notice.parentType = response.contractNotice ? response.type : 'CONTRACT_NOTICES';
						}
					} else {
						this.itemForEdit.contract_announcement = {
							...response,
							contractAuthority: response.contractNotice?.contractAuthority,
							details: response.contractNotice?.details,
							mediums: response.contractNotice?.mediums,
							number: response.contractNotice?.number,
							estimatedPurchaseValue: response.contractNotice?.estimatedPurchaseValue,
						};
					}
					this.inputFormAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
				},
			});
	}

	private filterContractNotices(filters: ManagementContractNoticeAndAnnouncementFilterRequest, startIndex?: number) {
		this.filtersStore = filters;

		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			this.apiContractNotice
				.getFilteredContractNoticesAndAnnouncements(
					this.filtersStore as ManagementContractNoticeAndAnnouncementFilterRequest,
					this.pagination.currentPage,
					this.ITEMS_PER_PAGE,
					undefined,
					this.autotagUiEnabled ? this.contractNoticesSortBy : undefined
				)
				.pipe(take(1))
				.subscribe({
					next: response => {
						this.itemsList = response.content || [];
						this.pagination.totalPages = response.totalPages || 0;
						this.pagination.totalElements = response.totalElements || 0;
						this.apiLoading = false;
					},
					error: () => {
						this.itemsList = [];
						this.pagination.totalPages = 0;
						this.apiLoading = false;
					},
				});
		}
	}

	private assignTagsContractNotices(dataIds: string[], tagIds: string[]) {
		this.apiLoading = true;
		const tagDto: ContractNoticeTagRequest = {
			dataIds,
			tagIds,
		};
		this.apiContractNotice
			.addContractNoticeTags(tagDto)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.preselectedItems = [];
					this.sharedService.requestActionInComponent.next({
						componentName: 'TagsComponent',
						action: 'DESELECT_TAGS',
					});
					this.actionByTypeSplitter({ action: 'LOAD' });
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.preselectedItems = [];
					this.apiLoading = false;
				},
			});
	}

	/** Marks a single contract notice as reviewed (autotag UI) and patches it in place in itemsList. */
	private reviewContractNotice(item: any) {
		if (!item?.id) {
			return;
		}
		this.apiContractNotice
			.reviewContractNotice(item.id)
			.pipe(take(1))
			.subscribe({
				next: response => {
					const list = this.itemsList as any[];
					const target = list.find(listItem => listItem.id === item.id);
					if (target) {
						target.reviewed = response.reviewed;
						target.color = response.color;
						target.riskScore = response.riskScore;
					}
					this.sharedService.showNotification.next({
						message: this.translate.instant('CONTRACT_NOTICES.REVIEW_SUCCESS'),
						type: 'SUCCESS',
					});
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error?.message || ''}`,
						type: 'ERROR',
					});
				},
			});
	}

	/**
	 * "Approve the safe ones" toolbar action (autotag UI) - applies the review decision to the
	 * given ids in one call. A rejected id is a normal outcome, not an error, so both counts are
	 * reported in a single toast.
	 */
	private reviewContractNoticesBulk(ids: string[]) {
		if (!ids.length) {
			return;
		}
		this.apiLoading = true;
		this.apiContractNotice
			.reviewContractNoticesBulk({ ids })
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.apiLoading = false;
					this.sharedService.showNotification.next({
						message: this.translate.instant('CONTRACT_NOTICES.REVIEW_BULK_RESULT', {
							approved: response.approvedIds?.length || 0,
							rejected: response.rejectedIds?.length || 0,
						}),
						type: 'SUCCESS',
					});
					this.actionByTypeSplitter({ action: 'LOAD' });
				},
				error: err => {
					this.apiLoading = false;
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error?.message || ''}`,
						type: 'ERROR',
					});
				},
			});
	}

	private assignTagsContractAnnouncements(dataIds: string[], tagIds: string[]) {
		this.apiLoading = true;
		const tagDto: ContractAnnouncementTagRequest = {
			dataIds,
			tagIds,
		};
		this.apiContractAnnouncements
			.addContractAnnouncementTags(tagDto)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
						type: 'SUCCESS',
					});
					this.preselectedItems = [];
					this.sharedService.requestActionInComponent.next({
						componentName: 'TagsComponent',
						action: 'DESELECT_TAGS',
					});
					this.actionByTypeSplitter({ action: 'LOAD' });
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.preselectedItems = [];
					this.apiLoading = false;
				},
			});
	}

	/** Language for management PDF reports — the backend expects the `Lang` enum (MK | EN | AL),
	 *  so it follows whichever language the admin has the interface in. */
	private get pdfReportLang(): string {
		return this.utils.languageManagement().toUpperCase();
	}

	private generateContractNoticePdfReport(id: string) {
		this.apiLoading = true;
		this.apiContractNotice
			.generatePdfReportForContractNoticeById(id, undefined, this.pdfReportLang)
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private generateContractAnnouncementPdfReport(id: string) {
		this.apiLoading = true;
		this.apiContractAnnouncements
			.generatePdfReportForContractAnnouncementById(id, undefined, this.pdfReportLang)
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private deleteContractNotice(contractNoticeIds: string[]) {
		this.apiLoading = true;
		this.apiContractNotice
			.deleteContractNotices({ contractNoticeIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_DELETED'),
						type: 'SUCCESS',
					});
					this.actionRequestedContractNotices({ action: 'FILTER' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private copyContractNotice(contractIds: string[]) {
		this.apiLoading = true;
		this.apiContractNotice
			.copyContractNotice({ contractIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_CREATED'),
						type: 'SUCCESS',
					});
					this.actionRequestedContractNotices({ action: 'FILTER' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private copyContractAnnouncement(contractIds: string[]) {
		this.apiLoading = true;
		this.apiContractAnnouncements
			.copyContractAnnouncement({ contractIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_CREATED'),
						type: 'SUCCESS',
					});
					this.actionRequestedContractNotices({ action: 'FILTER' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private deleteContractAnnouncement(contractAnnouncementIds: string[]) {
		this.apiLoading = true;
		this.apiContractAnnouncements
			.deleteContractAnnouncements({ contractAnnouncementIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_DELETED'),
						type: 'SUCCESS',
					});
					this.actionRequestedContractNotices({ action: 'FILTER' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}
	//** (END)Contract Notices methods */

	//** Sales methods */
	private actionRequestedSale(event: any) {
		switch (event.action) {
			case 'LOAD': {
				if (event.data === 'listItem') {
					this.getSale(event.id);
				} else {
					this.sharedService.requestActionInComponent.next({
						componentName: 'SalesFiltersComponent',
						action: 'FILTER_TRIGGER',
					});
				}
				return;
			}
			case 'FILTER': {
				this.filterSales(event.filters, event.id);
				return;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'UNSELECT_ALL': {
				this.selectedItems = [];
				this.unselectAllItems();
				break;
			}
			case 'GENERATE_REPORT': {
				if (event.type === 'SINGLE') {
					if (event.item.fileUrl && this.isPdfFile(event.item.fileUrl)) {
						window.open(event.item.fileUrl, '_blank');
					} else if (event.item.publicationUrl) {
						window.open(event.item.publicationUrl, '_blank');
					} else {
						this.generateSalePdfReport(event.item.id);
					}
				}
				break;
			}
			case 'TOOLBAR': {
				if (event.groupAction === 'DELETE' && this.selectedItems.length) {
					this.deleteSales(this.selectedItems.map(item => item.id));
				} else if (event.groupAction === 'SCROLL_TO_TOP' && this.listScrollAnchor) {
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
					this.scrollToTop.active = false;
				}
				break;
			}
		}

		this.sharedService.requestActionInComponent.next({
			componentName: 'SalesFormComponent',
			action: 'RESET_FORM',
		});
	}

	private getSale(id: string) {
		this.apiSales
			.getSale(id)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.itemForEdit.sale = response;
					this.inputFormAnchor.nativeElement.scrollIntoView({ behaviour: 'smooth', block: 'start' });
				},
			});
	}

	private filterSales(filters: SalesFilterRequest, startIndex?: number) {
		this.filtersStore = filters;
		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			this.apiSales
				.getSalesPageable(this.filtersStore as SalesFilterRequest, this.pagination.currentPage, this.ITEMS_PER_PAGE)
				.pipe(take(1))
				.subscribe({
					next: response => {
						this.itemsList = response.content || [];
						this.pagination.totalPages = response.totalPages || 0;
						this.pagination.totalElements = response.totalElements || 0;
						this.apiLoading = false;
					},
					error: () => {
						this.itemsList = [];
						this.pagination.totalPages = 0;
						this.apiLoading = false;
					},
				});
		}
	}

	private generateSalePdfReport(id: string) {
		this.apiLoading = true;
		this.apiSales
			.generatePdfReportForSaleById(id, undefined, this.pdfReportLang)
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private deleteSales(salesIds: string[]) {
		this.apiLoading = true;
		this.apiSales
			.deleteSales({ salesIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_DELETED'),
						type: 'SUCCESS',
					});
					this.actionRequestedSale({ action: 'FILTER' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}
	//** (END)Sales methods */

	//** Bankruptcies methods */
	private actionRequestedBankruptcy(event: any) {
		switch (event.action) {
			case 'LOAD': {
				if (event.data === 'listItem') {
					this.getBankruptcy(event.id);
				} else {
					this.sharedService.requestActionInComponent.next({
						componentName: 'BankruptciesFiltersComponent',
						action: 'FILTER_TRIGGER',
					});
				}
				return;
			}
			case 'FILTER': {
				this.filterBankruptcies(event.filters, event.id);
				return;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'UNSELECT_ALL': {
				this.selectedItems = [];
				this.unselectAllItems();
				break;
			}
			case 'GENERATE_REPORT': {
				if (event.type === 'SINGLE') {
					if (event.item.fileUrl && this.isPdfFile(event.item.fileUrl)) {
						window.open(event.item.fileUrl, '_blank');
					} else {
						this.generateBankruptcyPdfReport(event.item.id);
					}
				}
				break;
			}
			case 'TOOLBAR': {
				if (event.groupAction === 'DELETE' && this.selectedItems.length) {
					this.deleteBankruptcies(this.selectedItems.map(item => item.id));
				} else if (event.groupAction === 'SCROLL_TO_TOP' && this.listScrollAnchor) {
					this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
					this.scrollToTop.active = false;
				}
				break;
			}
		}

		this.sharedService.requestActionInComponent.next({
			componentName: 'BankruptciesFormComponent',
			action: 'RESET_FORM',
		});
	}

	private getBankruptcy(id: string) {
		this.apiBankruptcies
			.getBankruptcy(id)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.itemForEdit.bankruptcy = response;
					this.inputFormAnchor.nativeElement.scrollIntoView({ behaviour: 'smooth', block: 'start' });
				},
			});
	}

	private filterBankruptcies(filters: any, startIndex?: number) {
		this.filtersStore = filters;
		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			this.apiBankruptcies
				.getBankruptciesPageable(this.filtersStore as BankruptciesFilterRequest, this.pagination.currentPage, this.ITEMS_PER_PAGE)
				.pipe(take(1))
				.subscribe({
					next: response => {
						this.itemsList = response.content || [];
						this.pagination.totalPages = response.totalPages || 0;
						this.pagination.totalElements = response.totalElements || 0;
						this.apiLoading = false;
					},
					error: () => {
						this.itemsList = [];
						this.pagination.totalPages = 0;
						this.apiLoading = false;
					},
				});
		}
	}

	private generateBankruptcyPdfReport(id: string) {
		this.apiLoading = true;
		this.apiBankruptcies
			.generatePdfReportForBankruptcyById(id, undefined, this.pdfReportLang)
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private deleteBankruptcies(bankruptciesIds: string[]) {
		this.apiLoading = true;
		this.apiBankruptcies
			.deleteBankruptcies({ bankruptciesIds })
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_DELETED'),
						type: 'SUCCESS',
					});
					this.actionRequestedSale({ action: 'FILTER' });
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}
	//** (END) Bankruptcies methods */

	//** Helper methods */
	private isPdfFile(fileUrl: string): boolean {
		if (!fileUrl) {
			return false;
		}

		const lowercaseUrl = fileUrl.toLowerCase();
		return lowercaseUrl.includes('.pdf') || lowercaseUrl.includes('application/pdf') || lowercaseUrl.includes('pdf');
	}

	private unselectAllItems(): void {
		(this.itemsList as any[]).forEach(item => {
			if (item.checked) {
				item.checked = false;
			}
			if (item.relatedClips) {
				item.relatedClips.forEach((relatedItem: any) => {
					if (relatedItem.checked) {
						relatedItem.checked = false;
					}
				});
			}
		});
		
		this.preselectedItems = [];
	}
	//** (END) Helper methods */
}
